declare global {
  interface Window {
    gtag: (command: string, targetId: string, config?: any) => void;
  }
}

export interface GoogleAnalyticsEventConfig {
  event_category?: string;
  event_label?: string;
  value?: number;
  custom_parameters?: Record<string, any>;
  // GA4 accepts arbitrary top-level event parameters (e.g. page_slug on generate_lead).
  [eventParameter: string]: unknown;
}

interface GoogleAnalyticsGtagConfig extends GoogleAnalyticsEventConfig {
  event_callback?: () => void;
  event_timeout?: number;
}

const googleAnalyticsEnabled = (): boolean => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

export const trackGoogleAnalyticsEvent = async (
  eventName: string,
  config?: GoogleAnalyticsEventConfig
) => {
  if (!googleAnalyticsEnabled()) {
    return;
  }

  return new Promise<void>((resolve) => {
    const finalConfig: GoogleAnalyticsGtagConfig = {
      ...config,
      event_callback: () => {
        resolve();
      },
      event_timeout: 2000
    };

    window.gtag('event', eventName, finalConfig);
  });
};

export type ConversionConfig = Omit<GoogleAnalyticsEventConfig, 'event_category'>;

export const trackGoogleAnalyticsConversion = async (
  conversionEventName: string,
  config?: ConversionConfig
) => {
  const finalConfig = { event_category: 'conversion', ...(config ?? {}) };

  await trackGoogleAnalyticsEvent(conversionEventName, finalConfig);
};


export default {
  trackGoogleAnalyticsEvent,
  trackGoogleAnalyticsConversion
};
